import React from 'react';
import { Table, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions } from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat } from '../helpers/GlobalHelper';
import { Link } from "react-router-dom";

interface RawMaterialInOutData {
    id_items: number;
    item_name: string;
    item_code: string;
    category: string;
    unit_name: string;
    opening_date: string;
    opening_qty: number;
    stock_in_lc_purchase: number;
    stock_in_adjustment: number;
    stock_in_local_purchase: number;
    stock_out_manufacturing: number;
    stock_out_issue: number;
    stock_out_adjustment: number;
    current_stock: number;
}

interface RawMaterialInOutReportProps {

}

const RawMaterialInOutReport: React.FC<RawMaterialInOutReportProps> = () => {

    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState<RawMaterialInOutData[]>([]);
    const [formData, setFormData] = useState({
        idProjects: '',
        idItemCategories: '',
        fromDate: '',
        toDate: '',
    });

    const [projects, setProjects] = useState<any[]>([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const [itemCategories, setItemCategories] = useState<{ label: string; value: string }[]>([]);
    const [itemCategory, setItemCategory] = useState<{ label: string; value: string }>({ label: 'All Item Categories', value: '' });

    useEffect(() => {
        getProjects();
        getItemCategories();
    }, []);

    useEffect(() => {
        if (projects.length > 0) {
            setProject(projects[0]);
            setFormData((prevFormData) => ({
                ...prevFormData,
                idProjects: projects[0].value,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects]);

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                const projectObj = resp.data.map((item: any) => ({
                    ...item,
                    label: item.name,
                    value: item.id,
                }));
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
            });
    };

    const handleProjectChange = (selectedProject: any) => {
        setProject(selectedProject);
        if (selectedProject) {
            setFormData({ ...formData, idProjects: selectedProject.value });
        } else {
            setFormData({ ...formData, idProjects: '' });
        }
    };

    const getItemCategories = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'allItemCategories', getRequestOptions());
            const data = await response.json();

            if (data && Array.isArray(data)) {
                const categoryOptions = data.map((item: any) => ({
                    label: item.category_name,
                    value: item.id_item_categories,
                }));

                const allOption = { label: 'All Item Categories', value: '' };
                setItemCategories([allOption, ...categoryOptions]);
            }
        } catch (error) {
            console.error('Error fetching item categories:', error);
        }
    };

    const handleItemCategoryChange = (selectedCategory: any) => {
        setItemCategory(selectedCategory);
        if (selectedCategory) {
            setFormData({ ...formData, idItemCategories: selectedCategory.value });
        } else {
            setFormData({ ...formData, idItemCategories: '' });
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleViewReport = async () => {
        if (!formData.idProjects) {
            toast.error('Please select a project', { position: 'bottom-right', autoClose: 4000 });
            return;
        }
        if (!formData.fromDate || !formData.toDate) {
            toast.error('Please select both From Date and To Date', { position: 'bottom-right', autoClose: 4000 });
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'reports/raw-material-in-out', postRequestOptions(formData));
            const data = await response.json();

            if (data.success) {
                setReportData(data.data || []);
            } else {
                setReportData([]);
                if (data.errors && Array.isArray(data.errors)) {
                    data.errors.forEach((error: string) => toast.error(error, { position: 'bottom-right', autoClose: 4000 }));
                } else {
                    toast.error('Failed to load report', { position: 'bottom-right', autoClose: 4000 });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            toast.error('Error loading report data', { position: 'bottom-right', autoClose: 4000 });
        } finally {
            setLoading(false);
        }
    };

    const queryParams = new URLSearchParams(Object.entries(formData).map(([key, value]) => [key, String(value || '')]));

    const stickyGroupHeaderStyle: React.CSSProperties = {
        position: 'sticky',
        top: 0,
        zIndex: 1022,
        backgroundColor: '#f8f9fa',
        boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
    };

    const stickySubHeaderStyle: React.CSSProperties = {
        position: 'sticky',
        top: 38,
        zIndex: 1021,
        backgroundColor: '#f8f9fa',
        boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)',
        whiteSpace: 'nowrap',
    };

    const itemStockDetailsLink = (idItems: number) =>
        `/item-stock-details?id_items=${idItems}&id_projects=${formData?.idProjects}&id_warehouses=&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`;

    const purchaseLink = (idItems: number) =>
        `reports?type=detailPurchaseItemSearch&idProjects=${formData?.idProjects}&idItems=${idItems}&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`;

    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="itemCategory">
                                    <Form.Label>Item Category</Form.Label>
                                    <Select
                                        value={itemCategory}
                                        onChange={handleItemCategoryChange}
                                        options={itemCategories}
                                        placeholder={itemCategory.label}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="fromDate">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="From Date"
                                        name='fromDate'
                                        value={formData.fromDate}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="toDate">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="To Date"
                                        name='toDate'
                                        value={formData.toDate}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-1'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <button className='btn btn-sm btn-primary w-100 p-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span>View Report</span>
                                    </button>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <a
                                        className="btn btn-sm btn-primary w-100 p-3 mb-2"
                                        href={`${process.env.REACT_APP_BACKEND}raw_material_in_out_report_download?` + queryParams.toString()}
                                    >
                                        <i className='fas fa-download'></i> Excel Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>

            <div className='row'>
                <div className='col-12'>
                    <div style={{
                        maxHeight: 'calc(100vh - 300px)',
                        overflowY: 'auto',
                        overflowX: 'auto',
                        position: 'relative',
                    }}>
                        <Table bordered hover style={{ marginBottom: 0, width: '100%' }}>
                            <thead>
                                <tr>
                                    <th className='text-center' rowSpan={2} style={stickyGroupHeaderStyle}>Item Name</th>
                                    <th className='text-center' rowSpan={2} style={stickyGroupHeaderStyle}>Category</th>
                                    <th className='text-center' rowSpan={2} style={stickyGroupHeaderStyle}>Opening Date</th>
                                    <th className='text-center' rowSpan={2} style={stickyGroupHeaderStyle}>Opening Qty</th>
                                    <th className='text-center' colSpan={3} style={stickyGroupHeaderStyle}>Stock In</th>
                                    <th className='text-center' colSpan={3} style={stickyGroupHeaderStyle}>Stock Out</th>
                                    <th className='text-center' rowSpan={2} style={stickyGroupHeaderStyle}>Current Stock</th>
                                </tr>
                                <tr>
                                    <th className='text-center' style={stickySubHeaderStyle}>LC Purchase</th>
                                    <th className='text-center' style={stickySubHeaderStyle}>Local Purchase</th>
                                    <th className='text-center' style={stickySubHeaderStyle}>Adjustment</th>
                                    <th className='text-center' style={stickySubHeaderStyle}>Manufacturing</th>
                                    <th className='text-center' style={stickySubHeaderStyle}>Issue</th>
                                    <th className='text-center' style={stickySubHeaderStyle}>Adjustment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportData.length === 0 ? (
                                    <tr>
                                        <td colSpan={11} className='text-center'>No data available</td>
                                    </tr>
                                ) : (
                                    reportData.map((item: RawMaterialInOutData, index: number) => (
                                        <tr key={index}>
                                            <td>
                                                <Link to={itemStockDetailsLink(item.id_items)} target='_blank'>
                                                    {item.item_name || ''}
                                                </Link>
                                                {item.unit_name ? <small className='text-muted d-block'>{item.unit_name}</small> : null}
                                            </td>
                                            <td>{item.category || ''}</td>
                                            <td className='text-center'>{item.opening_date || ''}</td>
                                            <td className='text-end'>{numberFormat(item.opening_qty || 0)}</td>
                                            <td className='text-end'>
                                                <Link to={purchaseLink(item.id_items)} target='_blank'>
                                                    {numberFormat(item.stock_in_lc_purchase || 0)}
                                                </Link>
                                            </td>
                                            <td className='text-end'>
                                                <Link to={purchaseLink(item.id_items)} target='_blank'>
                                                    {numberFormat(item.stock_in_local_purchase || 0)}
                                                </Link>
                                            </td>
                                            <td className='text-end'>{numberFormat(item.stock_in_adjustment || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.stock_out_manufacturing || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.stock_out_issue || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.stock_out_adjustment || 0)}</td>
                                            <td className='text-end fw-bold'>{numberFormat(item.current_stock || 0)}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RawMaterialInOutReport;
